import { Autocomplete, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, MenuItem, OutlinedInput, Radio, RadioGroup, Select, TextField, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
// import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { MobileDatePicker } from '@mui/x-date-pickers';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import Page from '../../../../component/Page';
import TitlePage from '../../../../component/TitlePage';
import DatePicker from '../../../../component/DatePicker';
import { detailRawSeed, getMaterialsList, getZones, updateRawSeed } from '../../services/api';
import PintButton from '../../../../component/PintButton';
import ConfirmDialog from '../component/ConfirmDialog';
import ConfirmPrint from '../../component/confirmPrint';
import { getData } from '../../../../services/api';


var buddhistEra = require('dayjs/plugin/buddhistEra')
dayjs.extend(buddhistEra)
export default function StockRawDetail() {
    const { id } = useParams()
    const { profile, loading } = useSelector(state => state.profile)
    const location = useLocation();

    const navigate = useNavigate();
    const [refNoError, setRefNoError] = useState(false)
    const [senderOrReceiver, setSenderOrReceiver] = useState('')
    const [source, setSource] = useState('')
    const [documentDate, setDocumentDate] = useState(dayjs(new Date()))
    const [items, setItems] = useState([])
    const [materials, setMaterials] = useState([])
    const [detail, setDetail] = useState()
    const [branchs, setBranchs] = useState([])
    const [openPint, setOpenPint] = useState(false)
    const [open, setOpen] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [loadingPDF, setLoadingPDF] = useState(false);
    const [documentType, setDocumentType] = useState('รับ');
    const [seedType, setSeedType] = useState();

    const [rows, setRows] = useState([]);
    useEffect(() => {
        const getZonesList = async () => {
            const data = await getZones(profile?.BranchNo?.BranchNo)
            setBranchs(data)
        }
        getZonesList()
    }, [profile])

    useEffect(() => {
        const getDetail = async () => {
            const data = await detailRawSeed(id)
            setDetail(data)
            setDocumentDate(dayjs(data?.DocumentDate))
            setDocumentType(data?.DocumentType)
            setSeedType(data?.SeedType)
            setSource(data?.Source)
            setSenderOrReceiver(data?.SenderOrReceiver)
            setRows(data.Details)
        }
        getDetail()
    }, [id])

    useEffect(() => {
        const getMaterials = async () => {
            const data = await getMaterialsList()
            setMaterials(data)
        }
        getMaterials()
    }, [])
    useEffect(() => {
        if (location?.state?.new) {
            setOpenPint(true)
        }
    }, [location?.state?.new])
    const handleSubmit = () => {

        const body = {
            documentNo: id,
            DocumentDate: dayjs(documentDate).format('YYYY-MM-DD'),
            DocumentType: documentType,
            BranchNo: profile?.BranchNo?.BranchNo,
            SenderOrReceiver: senderOrReceiver,
            Source: source,
            SeedType: seedType,
            Status: "Y",
            Details: rows?.map((x) => (
                {

                    RefNo: x?.RefNo,
                    ItemNo: x?.ItemNo?.ItemNo,
                    Year: x?.Year || x?.ItemNo?.Year,
                    Lot: x?.Lot || x?.ItemNo?.Lot,
                    MaterialNo: x?.MaterialNo,
                    MaterialQty: +x?.MaterialQty.toString().replaceAll(',', ''),
                    Qty: +x?.Qty.toString().replaceAll(',', ''),
                    WarehouseNo: x?.WarehouseNo,
                    ZoneNo: x?.ZoneNo,
                    Remark: x?.Remark
                }
            ))
        }
        const post = async () => {
            const res = await updateRawSeed(body)
            if (res) {
                setLoadingSubmit(false)
                setOpen(false)
                setOpenPint(true)
            }
        }
        post()
    }
    const getLastLot = async (prefix) => {

        let _params = '';

        if (prefix) {
            _params = '?prefix=' + prefix;
        }
        // await getData(STOCK_CONFIG.requests.getLastLot.url + _params).then((response) => {
        //     if (response.status === true) {
        //         setLastLot(response.result)
        //     }
        // })
    }

    async function download() {
        setLoadingPDF(true)
        const res = await getData('raw-seed/movements' + `/${id}/pdf`, {
            responseType: 'arraybuffer'
        })
        const buffer = res.data
        const blob = new Blob([buffer], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        setLoadingPDF(false)
    }
    // console.log(rows)

    return (
        <Page>
            <TitlePage title='ข้อมูลเมล็ดพันธุ์' action={
                <PintButton loading={loadingPDF} download={download} />
            } />

            <div class="row" style={{ width: '80%' }}>

                <Box class="col-lg-5 col-md-6">
                    <Typography class="labelInput">ประเภททำรายการ</Typography>
                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                        <FormControl variant="standard" fullWidth disabled={id ? true : false}>
                            <Select value={documentType}
                                disableUnderline
                                onChange={e => setDocumentType(e.target.value)}
                                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                            >
                                <MenuItem value='รับ'>รับ</MenuItem>
                                <MenuItem value='จ่าย'>จ่าย</MenuItem>

                            </Select>
                        </FormControl>
                    </Box>
                </Box>
                <Box class="col-lg-5 col-md-6">
                    <Typography class="labelInput">วันที่ทำรายการ</Typography>
                    <DatePicker value={documentDate} onChange={e => setDocumentDate(e)} disabled={id ? true : false} />

                </Box>

                {documentType === 'รับ' ?
                    <>
                        <Box class="col-lg-5 col-md-6">
                            <Typography class="labelInput">รับจาก</Typography>
                            <Box className={`backgroundField ${refNoError ? 'error' : ''}`} sx={{ marginBottom: '10px' }}>
                                <TextField required value={senderOrReceiver} disabled={id ? true : false}
                                    // onBlur={e => {
                                    //     if (!e.target.value) {
                                    //         setRefNoError(true)
                                    //     } else {
                                    //         setRefNoError(false)
                                    //     }
                                    // }} 
                                    onChange={e => setSenderOrReceiver(e.target.value)} variant="standard" fullWidth
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                />
                            </Box>
                            {/* {refNoError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณากรอกเลขที่อ้างอิง</span>} */}
                        </Box>
                        <Box class="col-lg-5 col-md-6">
                            <Typography class="labelInput">สถานที่มา</Typography>
                            <Box className={`backgroundField ${refNoError ? 'error' : ''}`} sx={{ marginBottom: '10px' }}>
                                <TextField required value={source} disabled={id ? true : false}
                                    //  onBlur={e => {
                                    //     if (!e.target.value) {
                                    //         setRefNoError(true)
                                    //     } else {
                                    //         setRefNoError(false)
                                    //     }
                                    // }} 
                                    onChange={e => setSource(e.target.value)} variant="standard" fullWidth
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                />
                            </Box>
                            {/* {refNoError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณากรอกเลขที่อ้างอิง</span>} */}
                        </Box>
                    </> :
                    <Box class="col-lg-5 col-md-6">
                        <Typography class="labelInput">จ่ายให้</Typography>
                        <Box className={`backgroundField ${refNoError ? 'error' : ''}`} sx={{ marginBottom: '10px' }}>
                            <TextField required value={senderOrReceiver} disabled={id ? true : false}
                                //  onBlur={e => {
                                //     if (!e.target.value) {
                                //         setRefNoError(true)
                                //     } else {
                                //         setRefNoError(false)
                                //     }
                                // }}
                                onChange={e => setSenderOrReceiver(e.target.value)} variant="standard" fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                }}
                            />
                        </Box>
                        {/* {refNoError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณากรอกเลขที่อ้างอิง</span>} */}
                    </Box>}

            </div>
            <Box class="col-lg-5 col-md-12">
                <Typography class="labelInput">ประเภทเมล็ดพันธุ์</Typography>
                <RadioGroup row
                    value={seedType || ''}
                    onChange={e => setSeedType(e.target.value)}
                >
                    <FormControlLabel disabled={id ? true : false} value="ซื้อคืน" control={<Radio />} label="เมล็ดพันธุ์ซื้อคืน" />
                    <FormControlLabel disabled={id ? true : false} value='หลังปรับปรุง' control={<Radio />} label="เมล็ดพันธุ์หลังปรับปรุง" />
                </RadioGroup>
            </Box>



            {
                id &&
                <div class="row" style={{ width: '80%' }}>
                    <Box class="col-lg-5 col-md-6">
                        <Box sx={{ display: 'flex' }}>
                            <Typography class="labelInput">ผู้สร้าง</Typography><Typography class="message-error-label">( {dayjs(detail?.CreateDate).format('DD/MM/YYYY')} )</Typography>
                        </Box>
                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                            <TextField value={dayjs(detail?.CreateDate).format('DD/MM/YYYY')} variant="standard" fullWidth disabled={id ? true : false}
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true
                                }}
                            />
                        </Box>
                    </Box>
                    <Box class="col-lg-5 col-md-6">
                        <Box sx={{ display: 'flex' }}>
                            <Typography class="labelInput">ผู้แก้ไข</Typography> <Typography class="message-error-label">( {dayjs(detail?.ModifiedDate).format('DD/MM/YYYY')} )</Typography>
                        </Box>
                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                            <TextField value={dayjs(detail?.ModifiedDate).format('DD/MM/YYYY')} variant="standard" fullWidth disabled={id ? true : false}
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true
                                }}
                            />
                        </Box>
                    </Box>
                </div>
            }
            <TitlePage title='รายการเมล็ดพันธุ์' />
            <div class="receiveDetail row">
                <div class="col-md-12 table-responsive-sm" style={{ height: 'auto', overflowX: 'auto' }}>
                    <table class="table table-borderless" style={{ width: '1800px' }}>
                        <thead>
                            <tr>
                                <th class="text-center" >เลขที่อ้างอิง</th>
                                <th class="text-center ">เมล็ดพันธุ์</th>
                                <th class="text-center" >ชั้นพันธุ์</th>

                                <th class="text-center" >ฤดู</th>
                                <th class="text-center" >ปีที่ผลิต</th>

                                <th class="text-center" >ล็อตที่</th>
                                <th class="text-center" >ประเภทบรรจุภัณฑ์</th>

                                <th class="text-center" >จำนวน (กระสอบ)</th>
                                <th class="text-center" >ปริมาณ (กิโลกรัม)</th>
                                <th class="text-center" >ปริมาณเฉลี่ย/กระสอบ</th>
                                <th class="text-center" >โรงเก็บที่</th>
                                <th class="text-center" >หมายเหตุ</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody class="">
                            {rows?.map((x, i) => (
                                <tr >
                                    <td>
                                        <TextField value={x?.RefNo || ''}
                                            sx={{ background: '#fff' }}
                                            size='small' fullWidth variant='outlined'
                                            onChange={e => {
                                                const item = rows?.map((v, index) => {
                                                    v.RefNo = index === i ? e.target.value : v?.RefNo;
                                                    return v;

                                                });
                                                setRows(item);
                                            }}
                                        />
                                    </td>
                                    <td style={{ position: 'relative' }}>
                                        <Autocomplete
                                            size='small'
                                            options={items}
                                            disabled={id ? true : false}
                                            getOptionLabel={(option) => option?.ItemName}
                                            onBlur={e => {
                                                const item = rows?.map((v, index) => {
                                                    v.LotError = index === i ? x.ItemNo ? false : true : v?.LotError;
                                                    return v;
                                                });
                                                setRows([...item]);
                                            }
                                            }
                                            componentsProps={{
                                                paper: {
                                                    sx: {
                                                        width: 500
                                                    }
                                                }
                                            }}
                                            renderOption={(props, option) => (
                                                <Box component="li" {...props} key={option.ItemNo}>
                                                    {option?.CatalogNo?.CatalogName} {option?.Option2} <span style={{ color: option?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold', margin: '0 10px' }}>{option?.Season}</span> {option?.Option1} {option?.Chemical}
                                                </Box>
                                            )}
                                            value={x?.ItemNo}
                                            onChange={(event, newValue) => {
                                                const item = rows?.map((v, index) => {
                                                    v.LotGen = index === i ? null : v?.LotGen;
                                                    v.ItemNo = index === i ? newValue : v?.ItemNo;
                                                    return v;

                                                });
                                                setRows([...item]);

                                            }}

                                            renderInput={(params) => (
                                                <Box ref={params.InputProps.ref}>
                                                    <OutlinedInput error={!x?.LotError ? false : true} {...params.inputProps} fullWidth size='small' sx={{ padding: '0 !important', background: id ? '#e9ecef' : '#fff' }} />
                                                </Box>
                                            )}
                                        />
                                        {!x?.LotError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute' }}>กรุณาเลือกเมล็ดพันธุ์</span>}
                                    </td>
                                    <td class="text-center">{x?.ItemNo?.Option2}</td>
                                    <td class="text-center" style={{ color: x?.ItemNo?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold' }}>{x?.ItemNo?.Season}
                                    </td>
                                    <td style={{ display: "block", position: 'relative' }}>
                                        {documentType === 'รับ' ? <>   <TextField className='w-70' disabled={id ? true : false} error={!x?.YearError ? false : true} onBlur={e => {
                                            const item = rows?.map((v, index) => {
                                                v.YearError = index === i ? x.Year ? false : true : v?.YearError;
                                                return v;

                                            });
                                            setRows([...item]);
                                        }
                                        } value={x?.Year}
                                            size='small' variant='outlined'
                                            // onChange={e => {
                                            //     const branchNo = profile?.BranchNo?.BranchNo
                                            //     const breedClassNo = GetBreedClassNo(x?.ItemNo?.Option2)
                                            //     const seasonNo = GetSeasonNo(x?.ItemNo?.Season)
                                            //     const lotNumber = branchNo + breedClassNo + seasonNo + e.target.value;
                                            //     const item = rows?.map((v, index) => {
                                            //         v.Year = index === i ? e.target.value : v?.Year;
                                            //         v.LotGen = index === i ? lotNumber : v?.LotGen
                                            //         return v;

                                            //     });
                                            //     setRows([...item]);
                                            //     getLastLot(x?.LotGen)
                                            // }}
                                            sx={{ background: '#fff' }}
                                            inputProps={{ maxLength: 2 }}
                                            onKeyPress={(event) => {
                                                if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                }
                                            }} />
                                            {!x?.YearError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute', bottom: '-8px', left: "8px" }}>กรุณากรอกปี</span>}</> :
                                            <TextField className='w-70' value={x?.ItemNo?.Year}
                                                size='small' variant='outlined'
                                                sx={{ background: '#fff' }}
                                                inputProps={{ maxLength: 2 }}
                                                disabled
                                            />}
                                    </td>

                                    <td>
                                        {documentType === 'รับ' ?
                                            <div style={{ position: "relative" }}>
                                                <Box sx={{
                                                    display: 'flex', '& .MuiTextField-root': {
                                                        color: 'red',
                                                        '& .MuiOutlinedInput-root': { borderRadius: '0 .25rem .25rem 0' }
                                                    }
                                                }}>

                                                    <TextField error={!x?.LotGenError ? false : true} disabled={id ? true : false}
                                                        onBlur={e => {
                                                            const item = rows?.map((v, index) => {
                                                                v.LotGenError = index === i ? x.Lot.length === 3 ? false : true : v?.LotGenError;
                                                                return v;

                                                            });
                                                            setRows([...item]);
                                                        }} value={x?.Lot}
                                                        inputProps={{ maxLength: 3 }}
                                                        size='small' fullWidth variant='outlined' onChange={e => {
                                                            const item = rows?.map((v, index) => {
                                                                v.Lot = index === i ? e.target.value : v?.Lot;
                                                                return v;

                                                            });
                                                            setRows([...item]);
                                                        }} onKeyPress={(event) => {
                                                            if (!/[0-9]/.test(event.key)) {
                                                                event.preventDefault();
                                                            }
                                                        }} />

                                                </Box>
                                                {/* {!x?.LotGenError || lastLot ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute', bottom: '-16px' }}>กรุณากรอกเลขล็อต</span>} 
                                            {lastLot && <span style={{ fontSize: '12px', position: 'absolute', bottom: '-20px' }}>{`Lotล่าสุด  ${lastLot}`}</span>}
                                             */}
                                            </div> :
                                            <TextField value={x?.ItemNo?.Lot}
                                                size='small' variant='outlined'
                                                sx={{ background: '#fff' }}
                                                disabled
                                            />
                                        }

                                    </td>
                                    <td class="text-center">
                                        <FormControl className='w-120' variant="outlined" size='small' fullWidth
                                            error={x?.MaterialNoError} disabled={id ? true : false}
                                        >
                                            <Select value={x?.MaterialNo?.ItemNo} onChange={e => {
                                                const item = rows?.map((v, index) => {
                                                    v.MaterialNo = i === index ? e.target.value : v?.MaterialNo;
                                                    v.MaterialName = i === index ? materials?.find((x) => x?.ItemNo === e.target.value)?.ItemName : v?.MaterialName

                                                    return v;

                                                });
                                                setRows([...item]);
                                            }} onBlur={e => {
                                                const item = rows?.map((v, index) => {
                                                    v.MaterialNoError = index === i ? x.MaterialNo ? false : true : v?.MaterialNoError;
                                                    return v;

                                                });
                                                setRows([...item]);
                                            }} >
                                                {materials?.map((z, i) => {
                                                    return (
                                                        <MenuItem key={i} value={z?.ItemNo}>{z?.ItemName}</MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>
                                    </td>
                                    <td class="text-center">
                                        <TextField value={x?.MaterialQty.toLocaleString()} disabled={id ? true : false}
                                            sx={{ background: '#fff' }}
                                            type='tel' size='small' fullWidth variant='outlined' onChange={e => {
                                                let newValue = e.target.value.replace(/,/g, "");

                                                let abc = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                                const item = rows?.map((v, index) => {
                                                    v.MaterialQty = i === index ? abc : v?.MaterialQty;
                                                    v.OtyPer = i === index ? +x?.Qty?.toString().replaceAll(',', '') / +e.target.value.toString().replaceAll(',', '') : v?.OtyPer
                                                    return v;

                                                });
                                                setRows([...item]);
                                            }} onKeyPress={(event) => {
                                                if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                }
                                            }} />
                                    </td>
                                    <td class="text-center">
                                        <TextField value={x?.Qty.toLocaleString()} disabled={id ? true : false}
                                            sx={{ background: '#fff' }}
                                            type='tel' size='small' fullWidth variant='outlined' onChange={e => {
                                                let newValue = e.target.value.replace(/,/g, "");

                                                let abc = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                                const item = rows?.map((v, index) => {
                                                    v.OtyPer = i === index ? +e.target.value.toString().replaceAll(',', '') / +x?.MaterialQty.toString().replaceAll(',', '') : v?.OtyPer
                                                    v.Qty = i === index ? abc : v?.Qty;
                                                    return v;

                                                });
                                                setRows([...item]);
                                            }} onKeyPress={(event) => {
                                                if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                }
                                            }} /></td>
                                    <td class="text-center">
                                        {(+x?.Qty / +x?.MaterialQty)?.toFixed(2)}
                                    </td>
                                    <td style={{ position: "relative" }}>
                                        <FormControl className='w-120' variant="outlined" size='small' fullWidth disabled={id ? true : false}
                                            error={x?.WarehouseError}
                                        >
                                            <Select value={x?.WarehouseNo?.WarehouseNo} onChange={e => {
                                                const item = rows?.map((v, index) => {
                                                    v.WarehouseNo = i === index ? e.target.value : v?.WarehouseNo;
                                                    v.ZoneNo = i === index ? branchs?.find((x) => x?.WarehouseNo?.WarehouseNo === e.target.value).ZoneNo : v?.ZoneNo
                                                    v.WarehouseName = i === index ? branchs?.find((x) => x?.WarehouseNo?.WarehouseNo === e.target.value)?.WarehouseNo.WarehouseName : v?.WarehouseName
                                                    v.ZoneName = i === index ? branchs?.find((x) => x?.WarehouseNo?.WarehouseNo === e.target.value).ZoneName : v?.ZoneName
                                                    return v;

                                                });
                                                setRows([...item]);
                                            }} onBlur={e => {
                                                const item = rows?.map((v, index) => {
                                                    v.WarehouseError = index === i ? x.WarehouseNo ? false : true : v?.WarehouseError;
                                                    return v;

                                                });
                                                setRows([...item]);
                                            }} >
                                                {/* <MenuItem value='all' disabled>เลือกโรงเก็บ</MenuItem> */}
                                                {branchs?.map((z, i) => (
                                                    <MenuItem value={z?.WarehouseNo?.WarehouseNo}>{z?.WarehouseNo?.WarehouseName} {z?.ZoneName}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        {!x?.WarehouseError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute', bottom: '-6px', left: "8px" }}>กรุณาเลือกโรงเก็บ</span>}

                                    </td>
                                    <td class="text-center">
                                        <TextField className='w-90' value={x?.Remark} size='small' fullWidth variant='outlined' onChange={e => {

                                            const item = rows?.map((v, index) => {
                                                v.Remark = i === index ? e.target.value : v?.Remark;
                                                return v;

                                            });
                                            setRows([...item]);
                                        }}
                                        />
                                    </td>
                                    <td>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>
            </div>
            <hr class="chr" />
            <div class="row mt-4">
                <div class="col-12">
                    <Button onClick={() => navigate(location?.state?.new ? -2 : -1)} variant='outlined'
                        startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                        sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
                    <Button variant='contained' onClick={() => setOpen(true)} sx={{ width: '130px', fontSize: '14px' }}>{id ? 'แก้ไข' : 'บันทึก'}</Button>
                    <Button variant='contained' onClick={() => handleSubmit('N')} color='error' type='submit' sx={{ width: '130px', fontSize: '14px', marginLeft: '10px' }}>ยกเลิก</Button>
                </div>
            </div>
            <ConfirmDialog open={open} setOpen={setOpen} rows={rows} handleSubmit={handleSubmit} loadingSubmit={loadingSubmit} />
            <ConfirmPrint title={'บันทึกรายการคืนวัสดุสำเร็จ'} download={download} open={openPint} setOpen={setOpenPint} loadingPDF={loadingPDF} linkTo='/stock/stock-raw/add' />

        </Page >
    )
}
